/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import { useLayoutEffect, useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { useNavConfig } from 'src/layouts/dashboard';

import { Box, Stack, Typography } from '@mui/material';

import { useSubheader } from '../../_core/MetronicSubheader';

import { BreadCrumbs } from './components/BreadCrumbs';

function useBreadcrumbsFromNav(pathname) {
  const navSections = useNavConfig();

  return useMemo(() => {
    for (const section of navSections) {
      for (const child of section.children) {
        if (child.kind === 'leaf') {
          if (pathname.startsWith(child.href)) {
            return {
              breadcrumbs: [
                { pathname: section.href, title: section.label },
                { pathname: child.href, title: child.label },
              ],
              title: child.label,
            };
          }
        } else if (child.kind === 'group') {
          for (const leaf of child.children) {
            if (pathname.startsWith(leaf.href)) {
              return {
                breadcrumbs: [
                  { pathname: section.href, title: section.label },
                  { pathname: leaf.href, title: leaf.label },
                ],
                title: leaf.label,
              };
            }
          }
        }
      }
    }
    return { breadcrumbs: [], title: '' };
  }, [navSections, pathname]);
}

export function SubHeader() {
  const location = useLocation();
  const {
    title: overrideTitle,
    breadcrumbs: overrideBreadcrumbs,
    setTitle,
    setBreadcrumbs,
  } = useSubheader();
  const navFallback = useBreadcrumbsFromNav(location.pathname);

  // Pages may override title/breadcrumbs via useSubheader().setTitle/setBreadcrumbs.
  // Reset on route change so a stale override from the previous page doesn't leak.
  useLayoutEffect(() => {
    setTitle('');
    setBreadcrumbs([]);
  }, [location.pathname, setTitle, setBreadcrumbs]);

  const title = overrideTitle || navFallback.title;
  const breadcrumbs =
    overrideBreadcrumbs.length > 0 ? overrideBreadcrumbs : navFallback.breadcrumbs;

  return (
    <Box
      sx={{
        px: { xs: 2, sm: 3 },
        py: 1,
        borderBottom: 1,
        borderColor: 'divider',
        bgcolor: 'background.paper',
        display: 'flex',
        alignItems: 'center',
        flexWrap: 'wrap',
        minHeight: 48,
        gap: 1,
      }}
    >
      <Stack alignItems="center" direction="row" spacing={1}>
        {title && (
          <Typography fontWeight={700} variant="h6">
            {title}
          </Typography>
        )}
        <BreadCrumbs items={breadcrumbs} />
      </Stack>
    </Box>
  );
}
